export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PageBanner.vue?vue&type=template&id=03cac8d3&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PageBanner.vue?vue&type=template&id=03cac8d3&scoped=true&
// module id = 88
// module chunks = 0